import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as LineSvg } from "../../assets/images/icons/Line.svg";
import BasicSelect from "../Task/BasicSelect";
import {
  useFetchCompanyStructureQuery,
  useLazyFetchCompanyDataIdQuery,
  useLazyFetchCompanyStructureQuery,
} from "../../utils/company/companypermissions";
import { getCompanyId, getOrganizationName, getUserToken } from "../../utils/utilityFunctions/localServices";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import DatePickerComponent from "../UniversalComponents/DatePickerComponent";
import { usePostApiMutation, usePutApiMutation } from "../../utils/customer/customerTaskTable";
import { COMPANY_ADD, UPDATE_SECTION_FIELD } from "../../utils/constants";
import InputComponent from "../UniversalComponents/InputComponent";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";
import { Field } from "formik";
import AdvancedCompany from "./AdvancedCompany";
import { FormControlLabel, Switch } from "@mui/material";
import styled from "@mui/material/styles/styled";
import CompanyDelegation from "../CompanyAndPermission/CompanyDelegation";
import CompanyDelegation2 from "./CompanyDelegation2";
import { ReactComponent as PersonAvatar } from "../../assets/images/personAvatar.svg";
import CropComponent from "../UniversalComponents/CropComponent";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { ReactComponent as CameraIcon } from "../../assets/images/cameraIcon.svg";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import CompanyPage2 from "./CompanyPage2";

const CompanyDashboard = ({ EditCompanyData, setEditCompany, isEdit = false }) => {
  const [activeLink, setActiveLink] = useState(0);
  const [activeSubLink, setActiveSubLink] = useState("Company");
  const fileInputRef = useRef(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  // const [formData, setFormData] = useState(EditCompanyData || {});
  const [companyHeader, setCompanyHeader] = useState([]);
  const [isCompanyCreated, setIsCompanyCreated] = useState(false);
  const [CompanyName, setCompanyName] = useState({});
  const [companyenableornot, setCompanyenableornot] = useState(false);
  const [editButtonState, setEditButtonState] = useState(false);
  const [imageCropDrawerOpen, setImageCropDrawerOpen] = useState(false);
  const [tempSelectedFile, setTempSelectedFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [editButtonState1, setEditButtonState1] = useState(false);

  const navigate = useNavigate();

  const data = useParams();

  const [
    companyHeadervalue,
    {
      data: companyHeaderData,
      isLoading: companyHeaderDataLoading,
      isError: companyHeaderDataError,
      error: companyHeaderDataErrorData,
      isSuccess: companyHeaderDataSuccess,
    },
  ] = useLazyFetchCompanyStructureQuery();

  const [
    companyAdd,
    {
      isSuccess: companyAddSuccess,
      data: companyAddData,
      isLoading: companyAddLoading,
      isError: companyAddError,
      error: companyAddErrorResponse,
    },
  ] = usePostApiMutation();

  const [
    updateCompany,
    {
      isSuccess: updateCompanySuccess,
      data: updateCompanyData,
      isLoading: updateCompanyLoading,
      error: companyUpdateErrorResponse,
      isError: updateCompanyError,
    },
  ] = usePutApiMutation();

  const [
    CompanyGetValue,
    { data: companyEditData, isLoading: isCompanyEditDataLoading, error: companyEditDataError, refetch },
  ] = useLazyFetchCompanyDataIdQuery();

  useEffect(() => {
    //loading
    if (companyHeaderDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (companyHeaderDataSuccess) {
      if (companyHeaderData.success) {
        setCompanyHeader(companyHeaderData?.data);
      }
    }

    // catch block
    if (companyHeaderDataError) {
      dispatch(pushAlert({ message: companyHeaderDataErrorData?.data?.message, type: "danger", visible: true }));
    }
  }, [companyHeaderDataSuccess, companyHeaderDataError, companyHeaderDataLoading]);

  useEffect(() => {
    //loading
    if (companyAddLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (companyAddSuccess) {
      dispatch(
        pushAlert({
          message: companyAddData?.message,
          type: companyAddData.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );

      if (companyAddData?.success) {
        setIsCompanyCreated(true);
        setCompanyenableornot(true);
        const companyData = {
          company_id: companyAddData?.company_profile_id,
          company_name: companyAddData?.companyName,
          message: "Records Sucessfully created!",
        };
        localStorage.removeItem("company_data");
        localStorage.setItem("company_data", JSON.stringify(companyData));
        setEditCompany({});
        setCompanyName({ name: companyAddData?.companyName });
        navigate(`/edit_company/${companyAddData?.company_profile_id}`, { replace: true });
      }
    }

    // catch block
    if (companyAddError) {
      dispatch(pushAlert({ message: companyAddErrorResponse?.data?.message, type: "danger", visible: true }));
    }
  }, [companyAddLoading, companyAddSuccess, companyAddError]);

  useEffect(() => {
    // Show loader while updating
    if (updateCompanyLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    // Handle success response
    if (updateCompanySuccess) {
      dispatch(
        pushAlert({
          message: updateCompanyData?.message || "Company updated successfully",
          type: updateCompanyData?.success ? "success" : "danger",
          visible: true,
        })
      );

      if (updateCompanyData?.success) {
        setCompanyenableornot(true);
        handleTempFunc();
        // const companyData = {
        //   company_id: updateCompanyData?.company_profile_id,
        //   company_name: updateCompanyData?.companyName,
        //   message: "Records Sucessfully created!",
        // };
        // localStorage.removeItem("company_data");
        // localStorage.setItem("company_data", JSON.stringify(companyData));
        // setCompanyName({ name: updateCompanyData?.companyName });
      }
    }

    // Handle error response
    if (updateCompanyError) {
      dispatch(
        pushAlert({
          message: companyUpdateErrorResponse?.data?.message || "Failed to update company",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [updateCompanyLoading, updateCompanySuccess, updateCompanyError]);

  useEffect(() => {
    companyHeadervalue({
      page: "",
    });
  }, []);
  const transformFormData = (data) => {
    const formattedData = {};

    // 1. Convert fixed_company_info to general_info
    if (data.fixed_company_info) {
      const generalInfo = [];

      for (const [key, value] of Object.entries(data.fixed_company_info)) {
        if (key === "business_category") {
          generalInfo.push({
            key,
            value: value.default_value ?? "",
          });
        } else {
          generalInfo.push({
            key,
            value: value ?? "",
          });
        }
      }

      formattedData["general_info"] = generalInfo;
    }

    // 2. Convert each section to desired format
    if (Array.isArray(data.sections)) {
      data.sections.forEach((section) => {
        const sectionKey = section.section_key;
        const fieldValues = [];

        section.fields.forEach((field) => {
          fieldValues.push({
            key: field.key,
            value: field.value ?? field.default_value ?? "",
          });
        });

        formattedData[sectionKey] = fieldValues;
      });
    }

    return formattedData;
  };
  const handleTempFunc = async () => {
    try {
      const response = await CompanyGetValue({ id: data?.id, page: "" || "" });
      if (response?.data?.success) {
        const filterData = transformFormData(response?.data?.data);
        setEditCompany(filterData);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  console.log("editcompanydata", EditCompanyData);

  const handleFieldChange = (sectionKey, fieldKey, newValue) => {
    setEditCompany((prev) => {
      const existingFields = prev[sectionKey] || [];

      const updatedFields = existingFields.some((f) => f.key === fieldKey)
        ? existingFields.map((f) => (f.key === fieldKey ? { ...f, value: newValue } : f))
        : [...existingFields, { key: fieldKey, value: newValue }];

      return {
        ...prev,
        [sectionKey]: updatedFields,
      };
    });
  };

  const getFieldValue = (EditCompanyData, sectionKey, fieldKey) => {
    return EditCompanyData?.[sectionKey]?.find((field) => field.key === fieldKey)?.value ?? "";
  };

  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
      width: 42,
      height: 22,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(16px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "#65C466",
            opacity: 1,
            border: 0,
            ...theme.applyStyles("dark", {
              backgroundColor: "#2ECA45",
            }),
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "#33cf4d",
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          color: theme.palette.grey[100],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[600],
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.7,
          ...theme.applyStyles("dark", {
            opacity: 0.3,
          }),
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
      },
      "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        ...theme.applyStyles("dark", {
          backgroundColor: "#39393D",
        }),
      },
    })
  );

  const renderFieldByType = (field, sectionKey, handleFieldChange) => {
    const id = field.key;
    const currentValue = getFieldValue(EditCompanyData, sectionKey, field.key);
    const isEditDisabled = editButtonState && isEdit;

    switch (field.type) {
      case "text":
      case "string":
        return (
          <InputComponent
            id={id}
            type="text"
            placeholder={field.label}
            value={currentValue || ""}
            onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.value)}
            mandatory={field.mandatory ? true : false}
            error={!currentValue ? `${field.label} field is required` : ""}
            className={`w-full my-2 border-[#d2d5d7] rounded-md  ${((field.key === "company_name" && isEdit) || editButtonState) && "cursor-not-allowed bg-gray-200"} `}
            isDisabled={field.key === "company_name" && isEdit ? true : isEditDisabled}
          />
        );

      case "int":
      case "integer":
      case "number":
      case "float":
        return (
          <input
            id={id}
            type="number"
            value={currentValue ?? field.value ?? ""}
            onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.value)}
            mandatory={field.mandatory ? true : false}
            error={!currentValue ? `${field.label} field is required` : ""}
            className={`w-full my-2 border-[#d2d5d7] rounded-md  ${isEdit && editButtonState && "cursor-not-allowed bg-gray-200"} `}
            isDisabled={isEdit && isEditDisabled ? true : false}
          />
        );

      case "boolean":
      case "checkbox":
        return (
          // <input
          //   id={id}
          //   type="checkbox"
          //   checked={currentValue ?? field.value}
          //   onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.checked)}
          //   className="h-5 w-5"
          // />
          <FormControlLabel
            control={
              <IOSSwitch
                checked={currentValue ?? field.value}
                onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.checked)}
              />
            }
          />
        );

      case "date":
        return (
          <DatePickerComponent
            id={id}
            value={currentValue ?? field.value ?? ""}
            onChange={(date) => handleFieldChange(sectionKey, field.key, date)}
            className="w-full px-3 py-2 rounded-md border-[#d2d5d7]"
            placeholder="Select date"
          />
        );

      case "Dropdown":
      case "select":
        return (
          <div className="w-full  border-b-[1px] rounded-lg">
            <BasicSelect
              isMulti
              size="large"
              showSearch={field?.value?.length > 6 ? true : false}
              options={
                field.value?.map((option) => ({
                  label: option,
                  value: option,
                })) || []
              }
              id={id}
              selectedOptions={
                field.value
                  ?.filter((val) =>
                    EditCompanyData?.[sectionKey]?.some((item) => item.key === field.key && item.value === val)
                  )
                  .map((val) => ({
                    label: val,
                    value: val,
                  })) || []
              }
              isError={
                field.value?.some((val) =>
                  EditCompanyData?.[sectionKey]?.some((item) => item.key === field.key && item.value === val)
                )
                  ? false
                  : field.mandatory
                    ? true
                    : false
              }
              onEditColor={isEditDisabled}
              disabled={isEditDisabled ? true : false}
              onChange={(e) => handleFieldChange(sectionKey, id, e.target.value)}
              className="w-full px-3 py-2 border rounded-md bg-gray-100"
            />
          </div>
        );

      default:
        return (
          <input
            id={id}
            type="text"
            value={currentValue ?? field.value ?? ""}
            onChange={(e) => handleFieldChange(sectionKey, field.key, e.target.value)}
            className="w-full px-3 py-2 border rounded-md"
          />
        );
    }
  };

  const buildPayload = (formData) => {
    const fields = [];

    for (const sectionKey in formData) {
      // Remap general_info to fixed_company_info
      const actualSectionKey = sectionKey === "general_info" ? "fixed_company_info" : sectionKey;

      formData[sectionKey].forEach((field) => {
        fields.push({
          section_key: actualSectionKey,
          key: field.key,
          value: field.value,
          ...(field.default_value !== undefined && { default_value: field.default_value }),
          ...(field.field_order !== undefined && { field_order: field.field_order }),
        });
      });
    }

    return {
      company_id: data?.id,
      fields,
    };
  };

  const updateCompanydata = buildPayload(EditCompanyData);

  const handleCompanySubmit = (e) => {
    e.preventDefault();
    setEditButtonState(() => !editButtonState);
    // For error handling
    // const generalInfoFields = EditCompanyData["general_info"] || [];

    // const companyName = generalInfoFields.find((f) => f.key === "company_name")?.value?.trim();
    // const businessCategory = generalInfoFields.find((f) => f.key === "business_category")?.value?.trim();

    // if (!companyName || !businessCategory) {
    //   dispatch(
    //     pushAlert({
    //       message:  "Please fill Company Name and Business Category before submitting.",
    //       type: "danger",
    //       visible: true,
    //     })
    //   );
    //   return;
    // }
    if (!editButtonState) {
      if (isEdit) {
        updateCompany({ data: updateCompanydata, url: `${UPDATE_SECTION_FIELD}` });
      }
    }
    if (!isEdit) {
      setEditButtonState(() => false);
      companyAdd({ data: EditCompanyData, url: `${COMPANY_ADD}` });
    }
  };

  const sidebarLinks = [
    { title: "Company", path: "" },
    // { title: "Notification", path: "#" },
    // { title: "Sale", path: "#" },
    // { title: "Time", path: "#" },
    // { title: "Expanse", path: "#" },
    { title: "Advanced", path: "" },
    { title: "Company Delegation", path: "" },
  ];
  // /company-and-permission
  const handleMenuClick = (index, title) => {
    setActiveLink(index);
    setActiveSubLink(title);
  };

  const handleCloseCropDrawer = () => {
    setImageCropDrawerOpen(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setTempSelectedFile(URL.createObjectURL(file));
      setImageCropDrawerOpen(true);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      const dataTransferEvent = {
        target: {
          files: [file],
        },
      };
      handleFileChange(dataTransferEvent);
    }
  };

  const handleClear = () => {
    setEditCompany((prev) => ({
      ...(prev && []),
      general_info: prev.general_info ? [prev.general_info[0]] : [],
    }));
    setShowConfirmation((prev) => !prev);
  };

  return (
    <>
      <div className="flex w-full">
        {/* left title menu */}
        <div className="bg-[#FAFAFA] shadow-md rounded-lg w-[190px] border-[1px] border-[#D2DAE1] min-h-0 grow p-3 mr-3">
          <ul className="text-gray-600 rounded-md hover:text-[#F0F0F0]">
            {sidebarLinks?.map((link, index) => {
              const isCompany = link.title === "Company";
              const isDisabled = !companyenableornot && !isCompany;
              const onEditDisabled = editButtonState && isEdit;

              return (
                <li
                  key={index}
                  className={`w-full cursor-pointer rounded text-sm font-[400] leading-[18px] capitalize ${
                    data?.id && isEdit
                      ? "hover:bg-[#F0F0F0]"
                      : isDisabled
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-[#F0F0F0]"
                  }`}
                >
                  <NavLink
                    to={data?.id && isEdit ? link.path : isDisabled ? "#" : link.path || "#"}
                    onClick={(e) => {
                      if (data?.id && isEdit) {
                        e.preventDefault();
                        handleMenuClick(index, link.title);
                      } else {
                        if (isDisabled) {
                          e.preventDefault();
                        } else {
                          handleMenuClick(index, link.title);
                        }
                      }
                    }}
                    className={`px-2 py-2 flex items-center w-full justify-start text-sm ${
                      activeLink === index ? "text-black bg-[#F0F0F0] rounded-lg" : "text-[#888]"
                    } font-[400] leading-[18px] capitalize`}
                  >
                    {link.title}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>

        {/* showing the menu of left bar on active link */}
        {activeSubLink === "Company" && (
          <div className="flex w-full mr-4 bg-white rounded-lg border-[1px] border-[#D2DAE1] h-[calc(100vh-60px)]  overflow-x-hidden">
            <form
              onSubmit={handleCompanySubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  // Find the next focusable element
                  const focusableElements =
                    'button, [href],text,string,number,dropdown, input, select, textarea, [tabindex]:not([tabindex="-1"])';
                  const form = e.target.form;
                  const focusable = [...form.querySelectorAll(focusableElements)];
                  const index = focusable.indexOf(e.target);
                  // Move to next element or back to first if at end
                  const nextElement = focusable[index + 1] || focusable[0];
                  nextElement.focus();
                  return false;
                }
              }}
              isDisabled={editButtonState}
              className="w-full "
            >
              <div className="flex items-start justify-between flex-col w-full h-full px-3 pt-3 overflow-x-hidden thinscrollbar">
                <div className="flex items-start justify-start flex-col w-full h-fit gap-4">
                  <div className="flex items-start justify-start  w-full gap-4">
                    <div className="w-32 h-32 me-5">
                      <div
                        className={`border-dashed border-[#BCD0E3] h-full rounded-md ${selectedFile ? "" : "border-2"}`}
                        onDragOver={(event) => event.preventDefault()}
                        onDrop={handleDrop}
                      >
                        <div
                          id="image-preview"
                          className="max-w-sm rounded-lg flex items-center justify-center text-center cursor-pointer h-full relative group"
                        >
                          <input
                            id="upload"
                            name="customerfile"
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={handleFileChange}
                            ref={fileInputRef}
                          />
                          <label
                            htmlFor="upload"
                            className="cursor-pointer w-full h-full relative flex items-center justify-center bg-[#A9A9A970]"
                          >
                            {selectedFile ? (
                              <div className="relative w-full h-full">
                                <img
                                  src={selectedFile}
                                  alt="img preview"
                                  className="object-cover w-full h-full rounded-md "
                                />
                              </div>
                            ) : (
                              <PersonAvatar className="w-14 h-14" />
                            )}

                            {/* Overlay on hover */}
                            <div className="absolute inset-0 bg-black/30 backdrop-blur-sm opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-300 rounded-md">
                              <CameraIcon />
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="my-auto ml-4 text-2xl font-semibold text-[#2e4065] ">
                      {!isEdit
                        ? CompanyName?.name
                        : (EditCompanyData?.general_info && EditCompanyData?.general_info[0]?.value) ||
                          CompanyName?.name}
                    </div>
                  </div>

                  {/* sections */}
                  <div className="w-full">
                    {/* Fixed Company Info Sections */}
                    {companyHeader?.fixed_company_info &&
                      Object.entries(companyHeader.fixed_company_info).map(([sectionKey, section]) => (
                        <div
                          key={sectionKey}
                          className="flex flex-col items-center justify-start w-full border-[1px] border-[#D2DAE1] rounded-md p-4 gap-3 mb-4"
                        >
                          <div className="flex items-center justify-start w-full">
                            <span className="mr-2 text-[#2E333D] font-poppins text-base font-semibold capitalize">
                              {section.label}
                            </span>
                            <LineSvg />
                          </div>

                          {section?.fields ? (
                            <div className="w-full grid grid-cols-2 gap-x-28 gap-y-2">
                              {section.fields_order1?.map((fieldKey) => {
                                const field = section.fields[fieldKey];
                                return (
                                  <div key={fieldKey} className="flex items-center justify-between gap-4">
                                    <label className="w-1/3 text-[#434852] font-poppins text-base font-normal capitalize">
                                      {field.label}
                                    </label>
                                    {renderFieldByType(field, sectionKey, handleFieldChange)}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-red-500 font-medium">No fields found in this section.</div>
                          )}
                        </div>
                      ))}

                    {/* Other Company Info Sections */}
                    {companyHeader?.other_company_info?.sections_order?.map((sectionKey) => {
                      const section = companyHeader.other_company_info[sectionKey];
                      if (!section) return null;

                      return (
                        <div
                          key={sectionKey}
                          className="flex flex-col items-center justify-start w-full border-[1px] border-[#D2DAE1] rounded-md p-4 gap-3 mb-4"
                        >
                          <div className="flex items-center justify-start w-full">
                            <span className="mr-2 text-[#2E333D] font-poppins text-base font-semibold capitalize">
                              {section.label}
                            </span>
                            <LineSvg />
                          </div>

                          {section?.fields ? (
                            <div className="w-full grid grid-cols-2 gap-x-28 gap-y-2">
                              {section.fields_order1?.map((fieldKey) => {
                                const field = section.fields[fieldKey];
                                return (
                                  <div key={fieldKey} className="flex items-center justify-between gap-4">
                                    <label className="w-1/3 text-[#434852] font-poppins text-base font-normal capitalize">
                                      {field.label}
                                    </label>
                                    {renderFieldByType(field, sectionKey, handleFieldChange)}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-red-500 font-medium">No fields found in this section.</div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Buttons */}
                <div className="w-full bg-white flex justify-start py-3 mt-1 gap-3 sticky bottom-0 ">
                  <button
                    onClick={(e) =>
                      isEdit
                        ? editButtonState
                          ? e.preventDefault()
                          : setShowConfirmation((prev) => !prev)
                        : setEditCompany({})
                    }
                    type="button"
                    className=" w-24 h-8 flex justify-center items-center shrink-0 text-base rounded-md border text-[#383838] border-[#D2DAE1] bg-[#e6e5e5] hover:bg-[#f3f3f3]"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className=" w-24 h-8 flex justify-center items-center shrink-0 text-base rounded-md border text-[#FFFFFF] border-[#123251] bg-[#1D4469] hover:bg-[#1b3c5c]"
                  >
                    {isEdit ? (editButtonState ? "Edit" : "Update") : "Save"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}

        {activeSubLink === "Advanced" && (
          <div className="flex w-full mr-4 bg-white rounded-lg border-[1px] border-[#D2DAE1] h-[calc(100vh-60px)]  overflow-y-scroll thinscrollbar">
            <AdvancedCompany
              ischeck={isEdit}
              editButtonState1={editButtonState1}
              setEditButtonState1={setEditButtonState1}
            />
          </div>
        )}

        {activeSubLink === "Company Delegation" && (
          <div className="flex w-full mr-4 bg-white rounded-lg border-[1px] border-[#D2DAE1] h-[calc(100vh-60px)] ">
            <CompanyPage2 />
          </div>
        )}
        {imageCropDrawerOpen && (
          <CustomDrawer open={imageCropDrawerOpen} onClose={handleCloseCropDrawer}>
            <CropComponent
              tempSelectedFile={tempSelectedFile}
              setSelectedFile={setSelectedFile}
              onClose={handleCloseCropDrawer}
            />
          </CustomDrawer>
        )}

        {showConfirmation && (
          <ConfirmationDialog
            open={showConfirmation}
            onConfirm={handleClear}
            onClose={() => setShowConfirmation((prev) => !prev)}
            title="Discard"
            message={`Are you sure want to discard this data ?`}
            confirmVariant="discard"
            iconVariant="discard"
            confirmText="Yes"
            cancelText="No"
          />
        )}
      </div>
    </>
  );
};

export default CompanyDashboard;
